module.exports = __webpack_public_path__ + "img/14.223fb9dc.png";